import React, { Component } from 'react'
import { SelectField, MenuItem } from 'material-ui'
import { InformationIcon } from './'

class DropDown extends Component {
  getMenuItems() {
    const { items = [], valueToUpperCase = true } = this.props
    const menuItems = []
    items.forEach(item => {
      menuItems.push(
        <MenuItem
          value={item.id}
          primaryText={valueToUpperCase ? item.name.toUpperCase() : item.name}
          key={item.id}
        />
      )
    })
    return menuItems
  }

  render() {
    const {
      selected,
      onChange,
      header = '',
      width = 256,
      marginLeft = 0,
      marginRight = 0,
      disabled,
      color = '#3b424d',
      underlineFocusStyle,
      maxWidth,
      flex,
      marginTop = 0,
      iconColor = '#3fa6c1',
      iconHoverColor = '#77d8f4',
      showHelpIcon = false,
      onIconPressed
    } = this.props
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width,
          maxWidth,
          marginLeft,
          marginRight,
          marginTop,
          flex
        }}
      >
        <SelectField
          children={this.getMenuItems()}
          value={selected}
          onChange={(event, index, value) => onChange(value)}
          floatingLabelText={header.toUpperCase()}
          floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.3)' }}
          iconStyle={{ fill: disabled ? 'rgba(0, 0, 0, 0.3)' : color }}
          underlineFocusStyle={
            underlineFocusStyle ? underlineFocusStyle : { border: color }
          }
          underlineStyle={{ borderColor: color }}
          labelStyle={{ color: disabled ? 'rgba(0, 0, 0, 0.3)' : color }}
          style={{ flex: 1, marginRight: showHelpIcon ? 15 : 0, width: '' }}
          disabled={disabled}
        />
        {showHelpIcon ? (
          <InformationIcon
            color={iconColor}
            hoverColor={iconHoverColor}
            onClick={() => onIconPressed()}
          />
        ) : null}
      </div>
    )
  }
}

export { DropDown }



// WEBPACK FOOTER //
// ./src/components/common/DropDown.js